import { createContext } from "react";
import DispositionNode from "../interfaces/dispositionNode";
import DispositionInput from "../interfaces/disposition_input";

interface DispositionContextProps {
    openDispositionModal: ((parentID: string, dispositionNode?: DispositionNode) => void) | null;
    openDispositionInputModal: ((dispositionID: string, dispositionInput?: DispositionInput) => void) | null;
    openDeleteModalFunction: ((dispositionNode?: DispositionNode, dispositionInput?: DispositionInput) => void) | null;
    interactionMode: string[];
};

const defaultData: DispositionContextProps = {
    openDispositionModal: null,
    openDispositionInputModal: null,
    openDeleteModalFunction: null,
    interactionMode: []
};

const DispositionContext = createContext<DispositionContextProps>(defaultData);

export default DispositionContext;